export const defaultVisualEtiqueta = () => {
    return {
        regla: false,
        fecha_fab: false,
        cantidad: '',
        qr: false
    }
}

export default {
    idiomas: ['Espanol', 'Ingles', 'Portugues'],
    VisualEmpresa: defaultVisualEtiqueta(),
    version: 6,
    pdfet: {
        idioma: '',
        version: '',
        empresa: '',
        regla: '',
        fabfecha: '',
        rol: '',
        tipoproducto: '',
        cabecera: '',
        tipoEtiqueta: '',
        cantidad: '',
    },
    optempresa: [
        { value: '', text: '' }
    ]
}